import { atom } from 'jotai';

export interface Charger {
  BuildingID: string;
  NodeID?: string;
  Timestamp: string;
  NChans: number;
  NCharging: number;
  NWaiting: number;
  CState: number[];
  CPower: Array<number | null>;
  CEnergy: number[];
  /** Per-plug RMS voltage from Matter, null when not reported by the plug. Added 2026-06. */
  CVoltage?: Array<number | null>;
  /** Per-plug RMS current from Matter, null when not reported by the plug. Added 2026-06. */
  CCurrent?: Array<number | null>;
}

export interface BuildingIDProps {
  BuildingID: string | undefined;
}

export const chargingAtom = atom<{ [BuildingID: string]: Charger }>({});

export const toggleCharging = atom<'CPower' | 'CEnergy'>('CPower');
export const chargerScaleModeAtom = atom<'auto' | '10' | '1000'>('auto');
export const chargerTimeoutAtom = atom<{ [dataKey: string]: boolean }>({});
export const chargerShowAvailableOnlyAtom = atom<boolean>(true);

/** Historical plug power data for the plug power over time graph */
export interface ChargerHistoryRow {
  BuildingID: string;
  Timestamp: string;
  TimestampMs?: number;
  NCharging: number;
  NWaiting: number;
  CState: number[];
  CPower: Array<number | null>;
  CEnergy: number[];
}
export const plugPowerHistoryAtom = atom<{ [buildingID: string]: ChargerHistoryRow[] }>({});
